import { useSettings } from '../../hooks/queryHooks';
import { useDeviceRisk } from '../../hooks/useDeviceRisk';
import { useEffect } from 'react';

export const DeviceRisk = () => {
  const { settings } = useSettings();
  const setBlackbox = useDeviceRisk().setBlackbox;

  useEffect(() => {
    if (settings?.enableCreditInformationFlow && !window.IGLOO) {
      window.io_global_object_name = 'IGLOO';
      window.IGLOO = {
        bb_callback: (bb,) => {
          //always grab the current value in case the external scripts fail for reasons
          setBlackbox(bb);
        },
        enable_flash: false,
        loader: {
          version: 'general5',
          uri_hook: '/api/tu-proxy',
          subkey: import.meta.env.VITE_TU_SCRIPT_KEY
        }
      };

      const script = document.createElement('script');
      script.src = 'scripts/iovation.js';
      document.head.appendChild(script);
    }
  }, [setBlackbox, settings?.enableCreditInformationFlow]);

  return <></>;
};
